import axios from 'axios';
import { getCookie } from '@/utils/cookieHelper';
import { setThemeColor } from '@/utils/uiHelper';
import { isDevelopment } from '@/utils/environment';

// initial state
const initialState = {
  siteInfo: {
    name: 'Teamwork.com',
    logo: '',
    url: '',
    displayOptions: {
      allowRememberMe: false,
      hasTeamworkBranding: false,
      showSiteNameOnLoginScreen: false,
      themeColor: '',
      useBackgroundColorOnLogin: false,
      allowStandardLogin: true,
    },
    integrations: {
      googleSignIn: {
        enabled: true,
      },
    },
    sso: {
      enabled: true,
      loginStyle: '',
      hideStandardLoginLink: false,
    },
    apps: {
      projects: false,
      chat: false,
      desk: false,
    },
    twAuthBaseURL: 'https://tw-auth.teamwork.com',
    isEnterprise: false,
    installationState: '',
  },

  siteLoading: true,
  siteNotFound: false,

  productInfo: [
    {
      code: 'projects',
      title: 'Teamwork',
      description: 'The project management app for professionals',
    },
    {
      code: 'chat',
      title: 'Teamwork Chat',
      description: 'Instant chat software to keep your team connected',
    },
    {
      code: 'desk',
      title: 'Teamwork Desk',
      description: 'The helpdesk that\'s invisible for your customers',
    },
    {
      code: 'crm',
      title: 'Teamwork CRM',
      description: 'Sales pipeline management for small businesses ready to take the next step',
    },
    {
      code: 'spaces',
      title: 'Teamwork Spaces',
      description: 'A new kind of collaboration software',
    },
    {
      code: 'developer',
      title: 'Teamwork Developer Portal',
      description: 'Create and manage integrations for Teamwork products',
    },
  ],
};

// getters
const getters = {
};

// actions
const actions = {
  getSiteInfo({ commit, rootState, dispatch }, currentRoute) {
    const { isIframe } = rootState.login.meta;

    axios.get(`/launchpad/v1/info.json?isIframe=${isIframe}`).then((response) => {
      const info = response.data.info;

      // check if their domain has changed and this is an old url
      let parts = info.url.split('//');
      if (!isDevelopment && parts.length > 1) {
        parts = parts[1].split('/');
        const newHost = parts[0].toLowerCase();
        const oldHost = window.location.host.toLowerCase();
        if (newHost.indexOf('sunbeam.teamwork.localhost') === -1 && newHost !== oldHost) {
          // the basehref has changed, redirect to new url
          const base = info.url.substr(0, info.url.length - 1); // remove trailing slash
          const url = `${base}${window.location.pathname}${window.location.search.replace(oldHost, newHost)}`;
          window.location.href = url;
          return;
        }
      }

      commit('setLoggedIn', {
        loggedIn: response.data.loggedIn,
        userId: response.data.userId,
      });

      if (info.sso.enabled) {
        if (info.sso.loginStyle === 'SSO automatic-start' && currentRoute.path.indexOf('/login') === 0) {
          if (!isIframe) {
            window.location.href = `/launchpad/saml/start?SAMLAfterLoginURL=${encodeURIComponent(rootState.login.afterLoginURL)}`;
            return;
          }
          /**
           * We need to show button if we're in iframe because otherwise we
           * get 'popup blocked' browser message.
           */
          commit('setLoginState', 'saml-first', { root: true });
        } else if (info.sso.loginStyle === 'dual-login SSO-first') {
          commit('setLoginState', 'saml-first', { root: true });
        }
      }

      commit('setSiteInfo', info);

      const color = info.displayOptions.useBackgroundColorOnLogin ? info.displayOptions.themeColor : '';
      setThemeColor(color, rootState.login.meta.hasLocalStorage);

      dispatch('setPageTitle', currentRoute.meta.title);
    }).catch((e) => {
      // eslint-disable-next-line
      console.error(e);
      commit('setSiteNotFound');
    });
  },

  setPageTitle({ state }, pageTitle) {
    let title = `${pageTitle} - ${state.siteInfo.name}`;
    if (state.siteInfo.displayOptions.hasTeamworkBranding) title += ' - Teamwork.com';

    const launchpadLB = getCookie('LAUNCHPADLB');
    if (launchpadLB === 'beta') title = `🔥 BETA - ${title}`;

    document.title = title;
  },
};

// export `mutations` as a named export
export const mutations = {
  setSiteInfo(state, data) {
    state.siteInfo = data;
    state.siteLoading = false;
  },
  setSiteNotFound(state) {
    state.siteNotFound = true;
    state.siteLoading = false;
  },
};

export default {
  state: initialState,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/site.js